export default {
  layout: {
    tabEvents: "Eventi economici",
    eventsDescription:
      "Eventi economici e snapshot di allocazione sul libro mastro",
    tabExternal: "Pagamenti esterni",
    externalDescription: "Pagamenti PSP esterni",
    tabSettlements: "Liquidazioni",
    settlementsDescription: "Righe di liquidazione aperte per beneficiario",
  },
  shared: {
    emptyCell: "—",
    colCreated: "Creato",
    colType: "Tipo",
    colStatus: "Stato",
    colAmount: "Importo",
  },
  eventsList: {
    loadError: "Impossibile caricare gli eventi economici",
    colGross: "Lordo",
    colMethod: "Metodo",
    colLines: "Righe",
    colExternalPayment: "Pagamento",
    openRowAria: "Apri evento {{id}}",
    eventType: {
      CHECKOUT_CAPTURED: "Checkout",
      BOOKING_PAYMENT_CAPTURED: "Pagamento prenotazione",
      SELLER_FEE_FROM_RECEIPT: "Commissione scontrino",
      REFUND_REVERSAL: "Storno rimborso",
      SELLER_BANK_TRANSFER_SENT: "Bonifico inviato",
      SELLER_BANK_TRANSFER_RECEIVED: "Bonifico ricevuto",
    },
    eventStatus: {
      DRAFT: "Bozza",
      POSTED: "Registrato",
      REVERSED: "Stornato",
    },
    allocationMethod: {
      USER_PAYMENT: "Pagamento utente",
      SELLER_FEE: "Commissione venditore",
      REFUND: "Rimborso",
      TREASURY_SETTLEMENT: "Liquidazione tesoreria",
    },
  },
  externalList: {
    statusAll: "Tutti gli stati",
    openRowAria: "Mostra pagamento {{id}}",
    loadError: "Impossibile caricare i pagamenti esterni",
    statusCountsLoadError: "Impossibile caricare i conteggi per stato",
    linkedPayment: "Pagamento collegato",
    clearHighlight: "Rimuovi evidenziazione",
    selectedPayment: "Pagamento selezionato",
    providerFlow: "Provider / flusso",
    providerPaymentId: "ID pagamento provider",
    idempotencyKey: "Chiave di idempotenza",
    booking: "Prenotazione",
    paymentId: "ID pagamento",
    colProviderRef: "Rif. provider",
    colBooking: "Prenotazione",
    colPaymentId: "ID pagamento",
    paymentStatus: {
      CREATED: "Creato",
      AUTHORIZED: "Autorizzato",
      CAPTURED: "Incassato",
      FAILED: "Fallito",
      CANCELED: "Annullato",
      REFUNDED: "Rimborsato",
      REFUND_FAILED: "Rimborso fallito",
      PENDING: "In attesa",
      AWAITING_APP: "In attesa app",
      PENDING_RECONCILIATION: "Riconciliazione in corso",
      COMPLETED: "Completato",
      REVERTED: "Stornato",
    },
    paymentType: {
      CHECKOUT_PAYMENT: "Pagamento checkout",
      SELLER_PAYOUT: "Pagamento venditore",
    },
    provider: {
      SUMUP: "SumUp",
      MOCK: "Mock",
      REVOLUT: "Revolut",
    },
    flow: {
      CLOUD_POS: "Cloud POS",
      BANK_TRANSFER: "Bonifico",
    },
  },
  eventDetail: {
    splitAria: "Ripartizione per ruolo",
    technicalTitle: "Dati tecnici",
    technicalHint: "Snapshot delle regole di ripartizione e metadati grezzi",
    roles: {
      PROCESSOR_FEES: "Commissioni processore",
      SELLER: "Venditore",
      HOST: "Host",
      SALES_AGENT_ACTIVITY: "Agente vendite (attività)",
      SALES_AGENT_HOUSE: "Agente vendite (casa)",
      PLATFORM: "Piattaforma",
      TREASURY_CLEARING: "Clearing tesoreria",
    },
    loadError: "Impossibile caricare l’evento",
    loading: "Caricamento evento…",
    notFound: "Evento non trovato.",
    backToEvents: "Torna agli eventi",
    allEvents: "Tutti gli eventi",
    viewExternalPayment: "Vedi pagamento",
    cardTitle: "Evento economico",
    currency: "Valuta",
    grossAmount: "Importo lordo",
    idempotencyKey: "Chiave di idempotenza",
    ledgerEntries: "Movimenti sul libro mastro",
    bookingId: "ID prenotazione",
    checkoutId: "ID checkout",
    reversesEvent: "Storna evento",
    updated: "Aggiornato",
    jsonAllocationSnapshot: "Snapshot regole di ripartizione",
    jsonMetadata: "Metadati",
    jsonNone: "Nessuno",
    allocationLinesTitle: "Righe di ripartizione",
    allocationLinesSubtitle:
      "Snapshot congelato registrato sul libro mastro ({{count}} righe)",
    colStep: "Passo",
    colRole: "Ruolo",
    colStoredPercent: "% memorizzato",
    colAbsolutePercent: "% assoluto",
    colLedgerAccount: "Conto libro mastro",
    colLineId: "ID riga",
    noAllocationLines: "Nessuna riga di ripartizione",
  },
  settlements: {
    roles: {
      seller: "Venditore",
      host: "Host",
      salesAgent: "Agente vendite",
    },
    payees: {
      kpiPayeeCount_one: "{{count}} beneficiario",
      kpiPayeeCount_other: "{{count}} beneficiari",
      loadError: "Impossibile caricare i beneficiari",
      searchPlaceholder: "Nome o email",
      filterRole: "Ruolo",
      filterAllRoles: "Tutti i ruoli",
      filterDefault: "Aperte",
      filterToBePaid: "Da pagare",
      filterToBeInvoiced: "Da fatturare",
      colName: "Beneficiario",
      colRole: "Ruolo",
      colPayable: "Da pagare",
      colCommissionOpen: "Comm. da emettere",
      colSupplierOpen: "In attesa fatt. fornitore",
      legalIncompleteTooltip: "Dati legali incompleti",
      openRowAria: "Apri beneficiario {{name}}",
      amountWithCount: "{{amount}} ({{count}})",
      empty: "Nessun beneficiario trovato",
    },
    detail: {
      loadError: "Impossibile caricare le righe di liquidazione",
      loading: "Caricamento righe…",
      back: "Torna ai beneficiari",
      linesTitle: "Righe di liquidazione",
      linesSubtitle:
        "Seleziona le righe che determinano le azioni nel pannello a destra.",
      flowFilter: "Flusso",
      paymentFilter: "Pagamento",
      invoiceFilter: "Fattura",
      flowFilterAll: "Tutti",
      flowFilterUpfront: "Attività upfront",
      flowFilterReceiptBased: "Attività su ricevuta",
      flowFilterOutgoingCommissions: "Commissioni in uscita",
      paymentFilterAll: "Tutti",
      paymentFilterUnpaid: "Non pagati",
      paymentFilterPaid: "Pagati",
      paymentFilterUncollected: "Da incassare",
      paymentFilterCollected: "Incassati",
      invoiceFilterAll: "Tutte",
      invoiceFilterUninvoiced: "Da fatturare",
      invoiceFilterInvoiced: "Fatturate",
      invoiceFilterPending: "In attesa",
      invoiceFilterReceived: "Ricevute",
      deselectAll: "Deseleziona tutte",
      emptyFiltered: "Nessuna riga corrisponde ai filtri attuali",
      filteredCount: "{{shown}} di {{total}} righe",
      invoiceToInvoice: "Da fatturare",
      invoiceInvoiced: "Fatturata",
      invoiceSummaryNotSent: "Riepilogo non inviato",
      invoiceAwaitingInvoice: "In attesa di fattura",
      invoiceReceived: "Fattura ricevuta",
      paymentAwaiting: "In attesa",
      paymentReceived: "Ricevuto",
      paymentToPay: "Da pagare",
      paymentPaid: "Pagata",
      paymentNotAvailable: "Non disponibile",
      copyCollectionReference: "Copia riferimento incasso",
      copyInvoiceReference: "Copia riferimento fattura",
      copyPaymentReference: "Copia riferimento pagamento",
      actionsPanelTitle: "Azioni",
      actionsPanelSubtitle:
        "Esegui i passaggi di liquidazione per le righe selezionate.",
      selectionSummaryTitle: "Riepilogo selezione",
      readOnlyHint: "Hai accesso in sola lettura a questa liquidazione.",
      finalizedReadOnlyHint:
        "Questa liquidazione è fatturata e pagata, quindi i campi sono in sola lettura.",
      noActionsHint: "Seleziona delle righe per vedere le azioni disponibili.",
      selectMetricPayable: "Seleziona righe da pagare",
      selectMetricInvoiceable: "Seleziona righe con commissione da emettere",
      selectMetricCollectible: "Seleziona righe da incassare",
      selectMetricSupplierInvoice:
        "Seleziona righe in attesa fattura fornitore",
      openPayable: "Da pagare",
      openInvoiceable: "Commissione da emettere",
      openPendingSupplierInvoice: "In attesa fattura fornitore",
      openCollectible: "Da incassare",
      selectAll: "Seleziona tutte",
      selectLine: "Seleziona riga per {{activity}}",
      colEvent: "Evento",
      colInvoiceAmount: "Importo fattura",
      colInvoiceStatus: "Stato fattura",
      moneyDirectionOutgoing: "Denaro in uscita",
      moneyDirectionIncoming: "Denaro in entrata",
      colPaymentAmount: "Importo pagamento",
      colPaymentStatus: "Stato pagamento",
      viewFePdf: "Vedi",
      downloadFePdf: "Scarica",
      downloadFePdfError:
        "Impossibile scaricare il PDF della fattura commissioni",
      empty: "Nessuna riga di liquidazione",
      selectedPayable: "Pagabile selezionato",
      selectedInvoiceable: "Fatturabile selezionato",
      selectedCount: "Righe selezionate",
      markInvoiced: "Segna fatturato",
      markPaid: "Segna pagato",
      invoiceNotePlaceholder: "Nota per fattura commissione (opzionale)",
      collectionNotePlaceholder: "Nota per incasso (opzionale)",
      supplierNotePlaceholder: "Nota per fattura fornitore (opzionale)",
      paymentNotePlaceholder: "Nota per pagamento (opzionale)",
      referencePlaceholder: "Riferimento bonifico",
      referenceRequired: "Il riferimento del pagamento è obbligatorio",
      invoicedSuccess: "Righe selezionate segnate come fatturate",
      invoicedError: "Impossibile segnare le righe come fatturate",
      paidSuccess: "Righe selezionate segnate come pagate",
      paidError: "Impossibile segnare le righe come pagate",
      selectedCollectible: "Da incassare selezionato",
      viewSupplierInvoice: "Vedi fattura",
      downloadSupplierInvoice: "Scarica fattura",
      downloadSupplierInvoiceError:
        "Impossibile scaricare la fattura del fornitore",
      flowLabel: {
        UPFRONT: "Pagamento upfront",
        RECEIPT_BASED: "Pagamento receipt-based",
        SUPPLIER_PAYOUT: "Pagamento al fornitore",
      },
      flowHint: {
        UPFRONT:
          "Soldi già incassati: emetti la fattura della commissione e paga il venditore.",
        RECEIPT_BASED:
          "Invia la pro forma, registra il bonifico e poi emetti la fattura.",
        SUPPLIER_PAYOUT:
          "Invia il riepilogo, registra la fattura ricevuta e poi paga il venditore.",
      },
      mixedSelectionWarning:
        "Le righe selezionate appartengono a flussi di liquidazione diversi. Restringi la selezione a un solo flusso prima di eseguire azioni.",
      emailNever: "Mai inviata",
      emailLast: "Ultimo invio {{when}}",
      emailSentCount: "Inviata {{count}}×",
      steps: {
        summaryTitle: "Invia riepilogo",
        summaryDesc:
          "Invia al venditore l’email con il riepilogo delle transazioni selezionate (PDF allegato).",
        summaryButton: "Invia email di riepilogo",
        summaryResend: "Reinvia riepilogo",
        proformaTitle: "Invia pro forma",
        proformaDesc:
          "Invia al venditore la pro forma per le commissioni selezionate prima di registrare l’incasso.",
        proformaButton: "Invia email pro forma",
        proformaResend: "Reinvia pro forma",
        summarySuccess: "Email di riepilogo inviata",
        summaryError: "Impossibile inviare l’email di riepilogo",
        summaryAllInvoiced: "Tutte le righe selezionate sono già fatturate",
        summarySkipped: "Email non inviata: {{detail}}",
        invoiceTitle: "Emetti fattura",
        invoiceDesc:
          "Emetti la fattura della commissione per le righe selezionate.",
        collectTitle: "Registra incasso",
        collectDesc:
          "Registra il pagamento ricevuto dal venditore per le righe selezionate.",
        collectButton: "Registra incasso",
        collectSuccess: "Incasso registrato",
        collectError: "Impossibile registrare l’incasso",
        collectReferencePlaceholder: "Riferimento bonifico in entrata",
        supplierTitle: "Registra fattura ricevuta",
        supplierDesc:
          "Carica la fattura emessa dal venditore (un PDF può coprire più righe).",
        supplierRegisteredDesc:
          "Questa selezione ha già una fattura fornitore registrata.",
        supplierRegisteredUntitled: "Fattura registrata",
        supplierRegisteredAt: "Registrata {{when}}",
        supplierReplaceDesc: "Carica un nuovo file per sostituire la fattura registrata.",
        supplierReplaceButton: "Cambia fattura",
        supplierReplaceSubmit: "Salva sostituzione",
        supplierReplaceSuccess: "Fattura del fornitore sostituita",
        supplierReplaceError: "Impossibile sostituire la fattura del fornitore",
        supplierButton: "Registra fattura ricevuta",
        supplierNumberLabel: "Numero fattura",
        supplierNumberPlaceholder: "Es. 2026/123",
        supplierDateLabel: "Data fattura (opzionale)",
        supplierTotalLabel: "Totale €",
        supplierExpectedTotal: "Deve corrispondere alle righe selezionate: {{amount}}",
        supplierFileLabel: "File fattura (PDF o immagine)",
        supplierNumberRequired: "Inserisci il numero della fattura",
        supplierFileRequired: "Seleziona il file della fattura",
        supplierFileTooLarge: "File troppo grande. Dimensione massima {{max}}.",
        supplierFileUnsupported: "Carica un'immagine o un PDF della fattura.",
        supplierTotalRequired: "Inserisci il totale della fattura",
        supplierTotalInvalid: "Importo non valido (es. 1.234,56)",
        supplierTotalMismatch:
          "Il totale della fattura deve corrispondere alle righe selezionate ({{expected}}).",
        supplierSuccess: "Fattura del fornitore registrata",
        supplierError: "Impossibile registrare la fattura del fornitore",
        payTitle: "Emetti pagamento",
        payDesc:
          "Paga il venditore tramite Revolut o registra un pagamento manuale.",
        unavailableTitle: "Passaggio non pronto",
        unavailableGoBack: "Torna indietro",
        unavailableConfirm: "Procedi comunque",
        unavailableSummary: "Questo passaggio è sempre disponibile quando ci sono righe selezionate.",
        unavailableCollect:
          "Il riepilogo non è stato ancora inviato per tutte le righe selezionate. Procedere comunque?",
        unavailableSupplier:
          "Il riepilogo non è stato ancora inviato per tutte le righe selezionate. Procedere comunque?",
        unavailableInvoice:
          "I passaggi precedenti potrebbero non essere completati per tutte le righe selezionate (riepilogo, incasso o fattura ricevuta). Procedere comunque?",
        unavailablePay:
          "I passaggi precedenti potrebbero non essere completati per tutte le righe selezionate (riepilogo, fattura o incasso). Procedere comunque?",
      },
      revolut: {
        bannerTitle: "Payout Revolut in corso",
        status: "Stato: {{status}}",
        referenceLabel: "Causale / riferimento per Revolut",
        payButton: "Paga con Revolut",
        referenceRequired: "Inserisci un riferimento per il payout Revolut",
        initiated: "Payout Revolut avviato",
        completedToast: "Payout Revolut completato — righe aggiornate",
        pendingReconciliationLabel:
          "Allineamento contabile in corso (fondi già mossi verso Revolut; nuovi tentativi automatici)",
        failedToast: "Payout Revolut non riuscito o annullato",
        error: "Impossibile avviare il payout Revolut",
        legalRequired:
          "Il beneficiario deve avere i dati legali e l’IBAN completi",
        blockedActive:
          "È già presente un payout Revolut attivo per queste righe",
      },
    },
  },
} as const;
